export default __webpack_public_path__ + "static/media/event-10.96c904f3.jpg";